import ShadowContainerHorizontal from '@atoms/ShadowContainerHorizontal/ShadowContainerHorizontal';
import classNames from 'classnames';
import { motion } from 'framer-motion';

interface Props {
  readonly activeTabId: string;
  readonly activeTabTitleClassName?: string;
  readonly dataTestId?: string;
  readonly inactiveTabColour?: string;
  readonly shadowColour?: string;
  readonly shadowContainerClassName?: string;
  readonly tabs: {
    readonly id: string;
    readonly title: string;
  }[];
  readonly tabsSpacingClassName?: string;
  readonly tabTitleTypeClassName?: string;
  readonly underlineClassName?: string;
  readonly onTabChange: (activeTabId: string, activeTabTitle: string) => void;
}

const TabNavigation = ({
  activeTabId,
  activeTabTitleClassName,
  dataTestId = 'Tab-Navigation',
  inactiveTabColour = 'text-grey-450 dark:text-grey-500',
  shadowColour,
  shadowContainerClassName,
  tabs,
  tabsSpacingClassName = 'gap-5',
  tabTitleTypeClassName = 'h6',
  underlineClassName = 'h-[3px] bg-yellow',
  onTabChange,
}: Props) => (
  <ShadowContainerHorizontal
    shadowColour={shadowColour}
    hasTabbableNestedItems
    className={shadowContainerClassName}
  >
    <div className={classNames('flex', tabsSpacingClassName)}>
      {tabs.map(({ id, title }) => (
        <div
          className={classNames(
            'flex flex-col',
            activeTabId === id
              ? 'text-black-100 dark:text-white'
              : inactiveTabColour
          )}
          key={`tab-navigation-${title}`}
        >
          <button
            aria-label={title}
            onClick={() => {
              onTabChange(id, title);
            }}
            type="button"
            data-testid={`${dataTestId}-Button`}
          >
            <p
              className={classNames(tabTitleTypeClassName, {
                [`${activeTabTitleClassName}`]:
                  activeTabId === id && activeTabTitleClassName,
              })}
            >
              {title}
            </p>
          </button>

          <motion.div
            animate={{ opacity: activeTabId === id ? 1 : 0 }}
            className={classNames('rounded-full', underlineClassName)}
            exit={{ opacity: 0 }}
            initial={{ opacity: 0 }}
          />
        </div>
      ))}
    </div>
  </ShadowContainerHorizontal>
);

export default TabNavigation;
